export default "__VITE_ASSET__91c90b32__"